import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { StandAloneCfarDetails } from "./component";
import { IStoreState } from "../../../../../../reducers/types";
import { getSelectedAccountReferenceIdIfRedemptionEnabled } from "../../../../../rewards/reducer";
import {
  getHotelShopDateRange,
  getHotelShopSelectedLodging,
} from "../../../../../shop/reducer";
import { selectedCfarIdSelector } from "../../../../reducer";
import { setSelectedCfarId } from "../../../../actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  selectedAccountReferenceId:
    getSelectedAccountReferenceIdIfRedemptionEnabled(state),
  selectedCfarId: selectedCfarIdSelector(state),
  hotelShopDateRange: getHotelShopDateRange(state),
  selectedLodging: getHotelShopSelectedLodging(state),
});

const mapDispatchToProps = {
  setSelectedCfarId,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type StandAloneCfarDetailsConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedStandAloneCfarDetails = connector(
  withRouter(StandAloneCfarDetails)
);
